import { Enviroment } from './enviroment-v2.constant';

export const BucketMarketplace = `https://storage.cloud.google.com/pharol-marketplace/${Enviroment.COUNTRY}/`;
